import React from "react";
import {
  FaKey,
  FaUserLock,
  FaBolt,
  FaCode,
  FaShieldAlt,
  FaSyncAlt,
  FaChartLine,
  FaRedoAlt,
} from "react-icons/fa";

function MultiSignatureSupport() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/10.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Key Features of Bitcoin Wallet Offered by Xeer
                        Technology
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="services-style-four-items">
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaKey className="text-2xl text-black" size={35} />
                      </div>
                      <h4>Multi-Signature Support</h4>
                      <p>
                        Enhance the security of your Bitcoin wallet with
                        multi-signature functionality, which requires multiple
                        private keys to authorize a transaction. This adds an
                        extra layer of protection, particularly for business or
                        group transactions.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaUserLock className="text-2xl text-black" size={35} />
                      </div>
                      <h4>Full Control of Private Keys</h4>
                      <p>
                        Xeer Technology ensures you have full control over your
                        private keys, empowering you with complete ownership and
                        access to your Bitcoin. Your keys remain encrypted and
                        never leave your device, providing maximum security.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaBolt className="text-2xl text-black" size={35} />
                      </div>
                      <h4>Lightning Network Integration</h4>
                      <p>
                        Our wallets support the Lightning Network, enabling
                        faster and low-fee Bitcoin transactions. Ideal for users
                        who frequently conduct small, everyday transactions with
                        near-instant settlement times.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCode className="text-2xl text-black" size={35} />
                      </div>
                      <h4>SegWit and Bech32 Compatibility</h4>
                      <p>
                        Enjoy lower transaction fees and faster confirmations
                        with support for SegWit and Bech32 wallets, which
                        optimize Bitcoin transactions and improve scalability.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaShieldAlt
                          className="text-2xl text-black"
                          size={35}
                        />
                      </div>
                      <h4>Advanced Security Features</h4>
                      <p>
                        Xeer wallets come with built-in security measures like
                        two-factor authentication (2FA), biometric login
                        options, and encryption, protecting your assets from
                        unauthorized access or malicious threats.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaSyncAlt className="text-2xl text-black" size={35} />
                      </div>
                      <h4>Cross-Platform Syncing</h4>
                      <p>
                        Our Bitcoin wallets work seamlessly across multiple
                        platforms, including web, mobile, and desktop, allowing
                        you to manage your assets from any device with real-time
                        syncing.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaChartLine
                          className="text-2xl text-black"
                          size={35}
                        />
                      </div>
                      <h4>Real-Time Transaction Tracking</h4>
                      <p>
                        Stay updated with real-time tracking of your Bitcoin
                        transactions. Our wallet provides detailed transaction
                        history and monitoring tools to keep you informed every
                        step of the way.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaRedoAlt className="text-2xl text-black" size={35} />
                      </div>
                      <h4>Backup and Recovery Options</h4>
                      <p>
                        Easily backup your wallet with secure recovery options,
                        such as seed phrases and encrypted backups, to ensure
                        that your Bitcoin can be restored in case of device loss
                        or failure.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MultiSignatureSupport;
